import {
  Box,
  Flex,
  InputDescription,
  InputGroup,
  InputLabel,
  Text,
  TextArea,
} from '@huspy/briks-web';
import { VStack } from '@huspy/styled-system/jsx';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';
import BankIcon from '@components/v2/BankIcon';

const baseTranslation = 'opportunity.caseSubmission.submitApplications.textarea';

type Props = {
  title: string;
  subtitle: string;
  icons: { id: string; icon: string }[];
};
// eslint-disable-next-line react/display-name
export const SubmissionDetails = forwardRef<HTMLTextAreaElement, Props>(
  ({ icons, title, subtitle }, ref) => {
    const { t } = useTranslation();
    return (
      <VStack gap='40px' width='100%' alignItems='flex-start' h='100%'>
        <Box backgroundColor='base.white' borderRadius='radius-5' width='100%'>
          <VStack gap='spacing-14' w='100%'>
            <VStack gap='spacing-3' w='100%'>
              <Flex>
                {icons.map(({ id, icon }, i) => (
                  <BankIcon
                    key={ id }
                    icon={ icon }
                    height='64px'
                    width='64px'
                    pos='relative'
                    p='1'
                    style={ { ...(i !== 0 && { left: `-${i * 15}px` }) } }
                  />
                ))}
              </Flex>
              <VStack gap='0' w='100%'>
                <Text size='2xl' weight='medium' mb='4'>
                  {title}
                </Text>
                <Text size='md' color='text-tertiary'>
                  {subtitle}
                </Text>
              </VStack>
            </VStack>
            <VStack gap='spacing-7' w='100%'>
              <InputGroup w='100%'>
                <InputLabel
                  htmlFor='example'
                  fontWeight='regular'
                  color='text-tertiary'
                >
                  {t(`${baseTranslation}.label`)}
                </InputLabel>
                <TextArea
                  data-test='input-additional-text'
                  ref={ ref }
                  placeholder={ t(`${baseTranslation}.placeholder`) }
                />
                <InputDescription>
                  {t(`${baseTranslation}.hint`)}
                </InputDescription>
              </InputGroup>
            </VStack>
          </VStack>
        </Box>
      </VStack>
    );
  }
);
